import { BaseOwnerEntity } from "../../entity/baseOwnerEntity";

export class LoyaltyCardModel extends BaseOwnerEntity {
  id?: number;
  cardNumber?: string;
  cardTypeId?: number;
  firstActivationDate?: Date;
  startDate?: Date;
  endDate?: Date;
}
